<template>
    <div
        v-qa="'page-content-loader'"
        class="page-content-loader"
    >
        <LoadingAnimation />
    </div>
</template>

<script setup lang="ts">
import LoadingAnimation from '@/components/ui/LoadingAnimation.vue'
</script>

<style lang="scss" scoped>
.page-content-loader {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20vh;
}
</style>
